import Datepicker from "./Datepicker";
import Chart from 'chart.js';

export default class FacilityReportsOverview {
    constructor(selector) {
        this.$plugin = $(selector);
        if (this.$plugin.length === 0) {
            return false;
        }

        // Define class variables
        let $plugin = this.$plugin,
            vm = this,
            globalExcludedZinCodes = $plugin.attr('data-tncp-global-excluded-zin-codes');

        // Real constructor
        this.isLoading = false;
        this.titleNoData = $plugin.attr('data-tncp-plugin-no-data');
        this.$filter = $plugin.find('[data-tncp-filter]');
        this.$charts = $plugin.find('[data-tncp-chart]');
        this.globalExcludedZinCodes = (globalExcludedZinCodes) ? JSON.parse(globalExcludedZinCodes) : [];
        this.colorRegistry = [];
        this.color = {
            border: {
                default: '#eeeeef',
            },
            background: {
                ontime: '#122c82',
                overdue: '#b3363d',
                ok: '#122c82',
                nok: '#b3363d',
                ngk: '#ffb754',
                rest: '#122c8233',
                nodata: '#00000033',
                codes: [
                    // See https://lospec.com/palette-list/nanner-pancakes
                    '#a0ddd3',
                    '#6fb0b7',
                    '#577f9d',
                    '#4a5786',
                    '#3e3b66',
                    '#392945',
                    '#2d1e2f',
                    '#452e3f',
                    '#5d4550',
                    '#7b6268',
                    '#9c807e',
                    '#c3a79c',
                    '#dbc9b4',
                    '#fcecd1',
                    '#aad795',
                    '#64b082',
                    '#488885',
                    '#3f5b74',
                    '#ebc8a7',
                    '#d3a084',
                    '#b87e6c',
                    '#8f5252',
                    '#6a3948',
                    '#c57f79',
                    '#ab597d',
                    '#7c3d64',
                    '#4e2b45',
                    '#7a3b4f',
                    '#a94b54',
                    '#d8725e',
                    '#f09f71',
                    '#f7cf91',
                ],
            }
        };
        this.instances = [];
        new Datepicker(selector);

        // Initialize each chart
        _.forEach(this.$charts, (canvasElement) => {
            vm.initializeChart(canvasElement, 'pie');
        });

        // Execute data gathering on both page load and form submit
        vm.getResults();

        $('[data-tncp-filter]').on('submit', function (event) {
            event.preventDefault();

            vm.getResults();
        });
    }

    getLink(chart, index) {
        if (chart.config.data.enableLink) {
            let vm = this,
                itemText = chart.legend.legendItems[index].text,
                url = chart.canvas.dataset.tncpChartLink,
                dateFilters = $(this.$filter).serialize(),
                filter = '';

            if (itemText === 'Rest') {
                // Append global exclude ZIN codes to list
                if (vm.globalExcludedZinCodes) {
                    _.forEach(vm.globalExcludedZinCodes, (excludedZinCode) => {
                        filter = filter + '&tx_tuevnordcustomerportal_api[filter][excludedZinCodes]=' + excludedZinCode;
                    });
                }

                // Exclude all other ZIN codes from chart to filter by "Rest"
                chart.legend.legendItems.forEach(function (value) {
                    if (value.text !== 'Rest') {
                        filter = filter + '&tx_tuevnordcustomerportal_api[filter][excludedZinCodes]=' + value.text;
                    }
                });
            } else if (chart.canvas.dataset.tncpChartFilter) {
                filter = 'tx_tuevnordcustomerportal_api[filter][' + chart.canvas.dataset.tncpChartFilter + ']=' + itemText;
            }

            switch (chart.canvas.dataset.tncpChart) {
                case 'totalperformance':
                    if (itemText === 'overdue') {
                        filter = 'tx_tuevnordcustomerportal_api[filter][isOverdue]=true';
                    } else {
                        filter = 'tx_tuevnordcustomerportal_api[filter][isOverdue]=false';
                    }

                    break;
                case 'examinationresults':
                case 'examinationremarks':
                case 'examinationdefects':
                    if (chart.canvas.dataset.tncpChartType === 'comparison') {
                        dateFilters = dateFilters.replace(/ComparisonExaminationDate/g, 'ExaminationDate');
                    } else {
                        dateFilters = dateFilters.replace(/ReportingExaminationDate/g, 'ExaminationDate');
                    }

                    filter = filter + '&' + dateFilters;

                    break;
            }

            if (chart.canvas.dataset.tncpChartAdditionalFilter) {
                filter = filter + '&' + chart.canvas.dataset.tncpChartAdditionalFilter;
            }

            filter = filter.replace(/^&+/g, '');

            if (filter !== '') {
                url = url + '#!/' + btoa(filter);
            }

            window.open(url, '_blank').focus();
        }

        return false;
    }

    getResults() {
        const vm = this,
            xhrUrl = vm.$plugin.attr('data-tncp-retrievedata-xhr');

        if (!this.isLoading) {
            // Disable form
            vm.toggleForm(true);

            // Unset color registry
            vm.colorRegistry = [];

            // Prepare the request
            vm.request = window.xhrRequest({
                url: xhrUrl,
                method: 'POST',
                data: $(this.$filter).serialize()
            });

            // Execute the request
            vm.request.then((response) => {
                let data = [];

                // Get the data right
                _.forEach(response.data, (returnObject) => {
                    data.push(vm.prepareChartData(returnObject.identifier, returnObject.data));
                });

                // Draw the charts
                vm.drawCharts(data);

                // Enable form again
                vm.toggleForm(false);
            });
        }
    }

    initializeChart(chartElement, type) {
        let vm = this,
            $chart = $(chartElement),
            chart = new Chart(chartElement, {
                type: type,
                data: {
                    labels: [],
                    datasets: [{
                        label: '',
                        data: [],
                        backgroundColor: [],
                        borderColor: [],
                        borderWidth: 1
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: true,
                    aspectRatio: 1,
                    title: {
                        display: true,
                        padding: 0,
                        lineHeight: 1,
                        fontSize: 12,
                        text: $chart.attr('data-tncp-chart-title')
                    },
                    legend: {
                        position: 'right',
                        usePointStyle: true,
                        labels: {
                            fontSize: 10,
                            padding: 8,
                            usePointStyle: true,
                        },
                        onHover: function(event) {
                            event.target.style.cursor = 'pointer';
                        },
                        onClick: function (event, legendItem) {
                            return vm.getLink(chart, legendItem.index);
                        },
                    },
                    hover: {
                        onHover: function(event) {
                            let point = this.getElementAtEvent(event);

                            if (point.length) {
                                event.target.style.cursor = 'pointer';
                            } else {
                                event.target.style.cursor = 'default';
                            }
                        }
                    },
                    onClick: function(event) {
                        let activePoints = chart.getElementsAtEvent(event);

                        if (activePoints.length > 0) {
                            return vm.getLink(chart, activePoints[0]._index);
                        }

                        return false;
                    }
                },
                plugins: [{
                    beforeInit: function(chart) {
                        let legendOpts = chart.legend;

                        if (legendOpts) {
                            legendOpts.afterFit = function() {
                                legendOpts.width = 70;
                            };
                        }
                    }
                }]
            });

        this.instances.push({
            identifier: $chart.attr('data-tncp-chart') + '-' + $chart.attr('data-tncp-chart-type'),
            chart: chart
        });
    }

    prepareChartData(chartIdentifier, rawData) {
        let vm = this,
            filterResult = _.filter(vm.instances, function(filterChart) {
                return filterChart.identifier === chartIdentifier;
            }),
            chart = filterResult[0].chart,
            data = (typeof rawData === 'string') ? JSON.parse(rawData) : rawData,
            chartLabels = [],
            chartValues = [],
            restData = {
                label: '',
                count: 0,
            };

        // Break call
        if (!chart || !data) {
            return false;
        }

        // Gather new data, but remove last entry first (this is the total amount thingy thing)
        _.forEach(data, (dataObject) => {
            let codeColorFilter = _.filter(vm.colorRegistry, function(codeColor) {
                return codeColor.code === dataObject.reportDetail;
            });

            // Push code into colorRegistry if it does not exist yet
            if (codeColorFilter.length < 1) {
                vm.colorRegistry.push({
                    code: dataObject.reportDetail,
                    color: '',
                });
            }
            // TODO: Harden the "reportDetail" value by doing a lower case, spaceless value (see below TODO, here is just write process)
            // Regular data where we dont want to display 'total'
            if (dataObject.count > 0 && dataObject.reportDetail !== 'total') {
                // Store "rest" value so it can be appended after all the other data
                if (dataObject.reportDetail === 'Rest') {
                    restData.label = dataObject.reportDetail;
                    restData.count = dataObject.count;
                } else {
                    chartLabels.push(dataObject.reportDetail);
                    chartValues.push(dataObject.count);
                }
            }

            // If we dont have data at all, total still exists with value 0 but in order to create
            // a pie chart, we have to add a positive integer
            if (dataObject.count < 1 && dataObject.reportDetail === 'total') {
                chartLabels.push('total');
                chartValues.push(1);
            }
        });

        // Append "Rest" data to the end
        if (restData.count > 0) {
            chartLabels.push(restData.label);
            chartValues.push(restData.count);
        }

        // If we dont have data at all, total still exists with value 0 but in order to create
        // a pie chart, we have to add a positive integer
        if (chartLabels.length < 1 && chartValues.length < 1) {
            chartLabels.push('total');
            chartValues.push(1);
        }

        // Return necessary elements
        return {
            chart: chart,
            labels: chartLabels,
            values: chartValues
        };
    }

    drawCharts(data) {
        let vm = this,
            colorIterator = 0;

        _.forEach(data, (object) => {
            let chart = object.chart,
                chartLabels = object.labels,
                chartValues = object.values,
                codeColorFilter,
                borderWidth,
                backgroundColor = [];

            _.forEach(chartLabels, (label) => {
                codeColorFilter = _.filter(vm.colorRegistry, function(codeColor) {
                    return codeColor.code === label;
                });

                // TODO: Harden the code value by doing a lower case, spaceless value (see above TODO, here is just read process)
                // Set several background colors in a static way
                if (codeColorFilter[0].color === '') {
                    switch (codeColorFilter[0].code) {
                        case 'on time':
                            codeColorFilter[0].color = vm.color.background.ontime;
                            break;
                        case 'overdue':
                            codeColorFilter[0].color = vm.color.background.overdue;
                            break;
                        case 'OK':
                            codeColorFilter[0].color = vm.color.background.ok;
                            break;
                        case 'NOK':
                            codeColorFilter[0].color = vm.color.background.nok;
                            break;
                        case 'NGK':
                            codeColorFilter[0].color = vm.color.background.ngk;
                            break;
                        case 'Rest':
                            codeColorFilter[0].color = vm.color.background.rest;
                            break;
                        case 'total':
                            codeColorFilter[0].color = vm.color.background.nodata;
                            break;
                        default:
                            codeColorFilter[0].color = vm.color.background.codes[colorIterator];
                            colorIterator++;
                            break;
                    }
                }

                // Add color to background color array
                backgroundColor.push(codeColorFilter[0].color);
            });

            // Set new labels and interaction (error / no data case in 'else')
            if (chartLabels.length > 0 && chartLabels[0] !== 'total') {
                chart.data.labels = chartLabels;
                chart.data.enableLink = true;
                chart.options.tooltips.enabled = true;
                borderWidth = 1;
            } else {
                chart.data.labels = [vm.titleNoData];
                chart.data.enableLink = false;
                chart.options.tooltips.enabled = false;
                borderWidth = 0;
            }

            // Iterate through datasets
            _.forEach(chart.data.datasets, (dataset) => {
                dataset.data = chartValues;
                dataset.backgroundColor = backgroundColor;
                dataset.borderColor = vm.color.border.default;
                dataset.borderWidth = borderWidth;
            });

            // Update chart
            chart.update();
        });
    }

    toggleForm(disable = true) {
        this.$plugin.attr('data-form--isloading', disable);
        this.isLoading = disable;
    }
}
